
const publishedObjectList_query = `query{
  publishedObjectList{   
    
      contentType
      publishedDate
      objectId      
      ownerInfo
      {
        id
        userUuid
        firstName
        lastName
        username
        avatarFileName
        listings
        soldToys
        ratingNo
        ratingCount
        dateJoined
        isLoggedInUserFollowing
      
      }
      title
      uuid
      orignalPrice
      sellingPrice
      category
      shareUrl
      image
      commentNo
      likeNo
      shareNo
      content
      isLiked
      isInCollection
      comments
      {
          uuid
          userId
          {
            username
            avatarFileName
            isLoggedInUserFollowing
          }
        title
        content
        objectId
        contentType
        likeNo
        isLiked
        replies
        {
          uuid
          userId
          {
            username
            avatarFileName
            isLoggedInUserFollowing
          }
          content
          objectCommentId
          contentType
          likeNo
          isLiked
          createBy
          createDate
          updateDate
          updateBy
        }
        
      }      
  }     
}`;



module.exports = {
  PUBLISHED_OBJECT_LIST: publishedObjectList_query,
  
 
}
